import React, {Component} from 'react';
import reactCSS from "reactcss";
import {Col, Row} from "react-bootstrap";
import {SketchPicker} from "react-color";
import Colour_Picker from '../../components/Colour_Picker';
import Switcher from "../../components/Switcher";

class ShadowsPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            shadowSelected: false,
            shadow: {
                shadowColor: '#aaaaaa',
                r: 40,
                theta: 116,
                blur: 40,
                opacity: 100,
                size: 40
            },
            displayShadowColorPicker: false
        }
    }

    componentDidMount() {
        if (this.props.design_selection) {
            if (this.props.design_selection.get_parent('grid')) {
               this.updateFields(this.props.design_selection.get_parent('grid')['shadow'])
            } else {
                this.updateFields(this.props.design_selection['shadow'])
            }
        }
    }

    updateFields = (value) => {
        if (!value) return;
        let derefed = JSON.parse(JSON.stringify(value));
        derefed.opacity *= 100;
        derefed.r *= 20;
        derefed.blur *= 20;
        derefed.size *= 10;
        this.setState({'shadow': derefed, 'shadowSelected': true})
    }

    handleTextEffectsOnChange = (event) => {
        let min = 0
        let max = 100

        if (event.target.name === 'shadow_theta') {
            min = -180;
            max = 180;
        }

        if (event.target.name.includes('olor') || this.isValidInput(event.target.value, min, max)) {
            let name = event.target.name;
            let value = event.target.value;
            name = name.split('shadow_')[1];

            let value_text = value;

            if (name === 'opacity') {
                value_text /= 100;
            }
            if (name === 'r') {
                value_text /= 20;
            }
            if (name === 'blur') {
                value_text /= 20;
            }
            if (name === 'size') {
                value_text /= 10;
            }

            let values = {}
            values['shadow'] = this.state.shadow;
            values['shadow'][name] = value;

            let values_text = JSON.parse(JSON.stringify(values));
            values_text['shadow'].r /= 20;
            values_text['shadow'].blur /= 20;
            values_text['shadow'].opacity /= 100;
            values_text['shadow'].size /= 10;

            this.set_state(values);
            this.applyShadow(values_text);
        }
    };


    applyShadow = (values) => {
        if (this.props.design_selection) {
            if (this.props.design_selection.get_parent('grid')) {
                this.props.design_selection.get_parent('grid')['shadow'] = values['shadow'];
            } else {
                this.props.design_selection['shadow'] = values['shadow'];
            }
            window.design_editor.needs_redraw = true;
        }
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    isValidInput = (inp, min, max) => {
        if (inp === "") return true;
        let val = parseFloat(inp);
        return (!isNaN(val) && val >= min && val <= max);
    };

    handleClickShadowColorPicker = () => {
        this.setState({displayShadowColorPicker: !this.state.displayShadowColorPicker})
    };

    handleCloseShadowColorPicker = () => {
        this.setState({displayShadowColorPicker: false})
    };

    shadowOnClick = () => {
        let values = {shadowSelected: !this.state.shadowSelected}
        this.set_state(values).then(() => {
            if (!this.state.shadowSelected){
                this.applyShadow({'shadow': null})
            }
            else {
                let values = {}
                values['shadow'] = this.state.shadow;
                let values_text = JSON.parse(JSON.stringify(values));
                values_text['shadow'].r /= 20;
                values_text['shadow'].blur /= 20;
                values_text['shadow'].opacity /= 100;
                values_text['shadow'].size /= 10;
                this.applyShadow(values_text)
            }
        })
    }

    ShadowDropper = () => {
        const styles = reactCSS({
            'default': {
                color: {
                    width: '30px',
                    height: '30px',
                    borderRadius: '15px',
                    'border': '1px',
                    background: this.state.shadow.shadowColor
                },
                swatch: {
                    padding: '2.5px',
                    borderRadius: '15px',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                    zIndex: '-1'
                },
            },
        });

        return (<div>
            <Row style={{marginBottom: 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize: '1.5rem'}}>
                    Offset
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="shadow_r" min="0" max="100"
                           value={this.state.shadow.r} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="shadow_r"
                           onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.shadow.r}/>
                </Col>
            </Row>
            <Row style={{marginBottom: 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize: '1.5rem'}}>
                    Direction
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="shadow_theta" min="-180" max="180"
                           value={this.state.shadow.theta} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="shadow_theta"
                           onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.shadow.theta}/>
                </Col>
            </Row>
            <Row style={{marginBottom: 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize: '1.5rem'}}>
                    Blur
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="shadow_blur" min="0" max="100"
                           value={this.state.shadow.blur} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="shadow_blur"
                           onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.shadow.blur}/>
                </Col>
            </Row>
            <Row style={{marginBottom: 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize: '1.5rem'}}>
                    Opacity
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="shadow_opacity" min="0" max="100"
                           value={this.state.shadow.opacity} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="shadow_opacity"
                           onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.shadow.opacity}/>
                </Col>
            </Row>
            <Row style={{marginBottom: 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize: '1.5rem'}}>
                    Size
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="shadow_size" min="0" max="100"
                           value={this.state.shadow.size} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="shadow_size"
                           onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.shadow.size}/>
                </Col>
            </Row>
            <Row style={{marginBottom: 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize: '1.5rem'}}>
                    Color
                </Col>
                <Col xs={9} className="adjustment-controls-text" style={{float: 'right', paddingTop: 0}}>
                    <div>
                        <div style={styles.swatch} onClick={this.handleClickShadowColorPicker}>
                            <div style={styles.color}/>
                        </div>
                        {this.state.displayShadowColorPicker ? <div style={styles.popover}>
                            <div style={styles.cover} onClick={this.handleCloseShadowColorPicker}/>
                            <Colour_Picker user={this.props.user} 
                                presetColors={['#ffffff', '#f3ec3a', '#f9bd17', '#f99b1d', '#f15523', '#ef3124', '#DE0081', '#a71e48', '#7c3597', '#463191', '#000000', '#3d5dac', '#1296ce', '#63b145', '#19BC81', '#d0dd36']}
                                disableAlpha={true} color={styles.color.background} onChange={(e) => {
                                this.handleTextEffectsOnChange({target: {value: e.hex, name: 'shadow_shadowColor'}})
                            }}/>
                        </div> : null}
                    </div>
                </Col>
            </Row>
        </div>)
    }

    render() {
        return (
            <div>
                <Row>
                    <Switcher Dropper={this.ShadowDropper} show_dropper={this.state.shadowSelected}
                              trigger_on_click={this.shadowOnClick} title="Shadow"/>
                </Row>
            </div>
        )
    }


}

export default ShadowsPanel;